export const runtimeConfig = {
    get apiHost(): string {
        return import.meta.env.VITE_API_HOST ?? '';
    },
    get chatApiHost(): string {
        return import.meta.env.VITE_CHAT_API ?? '';
    },
    get vibeBuilderRemoteUrl(): string | undefined {
        return import.meta.env.VITE_VIBE_BUILDER_REMOTE_URL;
    }
};
